import React, { Component } from 'react';
import LoadableComponent from '../PlaceholderLoading/LoadableComponent';
import ContentLoadPlaceholder from '../PlaceholderLoading/Templates/Content/ContentLoadPlaceholder';
import ContentLoadErrorPlaceholder from '../PlaceholderLoading/Templates/Content/ContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript'
import { Configuration } from '../../types/Configuration';

type Props = {
    configuration: Configuration,
    selectedLanguage: string,
    onLoadCallback: () => void,
    onErrorCallback: () => void
}

type State = {
    scriptsToBeLoaded: LoadScript[]
}

class DWFooter extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: []
        };
    }

    componentDidMount() {
        this.setState({
            scriptsToBeLoaded: [
                { url: `${this.props.configuration.dwFooterBaseUrl}/build/dw-footer.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.dwFooterBaseUrl}/build/dw-footer.js`, type: "application/javascript", nomodule: true },
            ]
        })
    }

    render() {
        const message = <Translation>{t => t("Unfortunately we could not load this menu.")}</Translation>;

        return (
            <LoadableComponent
                loadPlaceholder={ContentLoadPlaceholder}
                errorPlaceholder={ContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                {... this.props}>
                <dw-footer language={this.props.selectedLanguage} />
            </LoadableComponent>
        )
    }
}

export default DWFooter;